import React from "react";

export default function Header({ icon: Icon, title, subtitle, children }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        flexWrap: "wrap",
        gap: "1rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
        {Icon && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--brand)",
              background: "var(--brand-light)",
              padding: "0.4rem",
              borderRadius: "0.6rem",
            }}
          >
            <Icon size={20} />
          </div>
        )}
        <div>
          <h1
            style={{
              margin: 0,
              fontSize: "1.4rem",
              color: "var(--text)",
            }}
          >
            {title}
          </h1>
          {subtitle && (
            <p
              style={{
                margin: "0.2rem 0 0",
                color: "var(--muted)",
                fontSize: "0.9rem",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* дополнительные элементы справа */}
      {children && (
        <div style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
          {children}
        </div>
      )}
    </div>
  );
}
